import Icon from '~/components/common/Icon';
import { ALERT_TYPE } from '~/constants';
import { always, cond, propEq } from 'ramda';
import * as React from 'react';

import styles from './notifiactionIcon.module.scss';

type Props = {
  notification: { type: string };
};

const NotificationIcon: React.FC<Props> = ({ notification }) => {
  const name = cond([
    [propEq('type', ALERT_TYPE.SUCCESS), always('alertSuccess')],
    [propEq('type', ALERT_TYPE.INFO), always('alertInfo')],
    [propEq('type', ALERT_TYPE.WARNING), always('alertWarning')],
    [propEq('type', ALERT_TYPE.ERROR), always('alertError')],
  ])(notification);
  return (
    <div className={styles.notificationIcon}>
      <Icon name={name} />
    </div>
  );
};

export default NotificationIcon;
